export const MOBILE_SLIDER_PAGES_IDS = {
    ACADEMY_COURSE: 'academy-course',
    ACADEMY_LESSON: 'academy-lesson',
    ACCOUNT_STAT: 'stat',
    ACHIEVEMENT: 'achievement',
    ADVANCED_SETTINGS: 'advanced-settings',
    ALERTS: 'alerts',
    APPEARANCE: 'appearance',
    ASSET: 'asset',
    BEGINNERS_GUIDE: 'beginners-guide',
    CLIENT_AGREEMENT: 'client-agreement',
    COLLECTION: 'collection',
    COMMUNITY: 'community',
    DELETE_PROFILE: 'delete-profile',
    DEMO_LIMITS: 'demo-limits',
    DEPOSIT: 'deposit',
    DEPOSIT_SURVEY: 'deposit-survey',
    EMAIL_CONFIRMED: 'email-confirmed',
    GLORY_ARENA: 'glory-arena',
    GRAPH: 'graph',
    HISTORY: 'history',
    HISTORY_INFO: 'history-info',
    OPEN_MOBILE_APP: 'open-mobile-app',
    ORDER_UPDATE_2: 'update-order',
    POSITION_CREATE: 'create',
    POSITION_UPDATE: 'position-update',
    POSITION_UPDATE_2: 'update-position',
    PRIVACY_POLICY: 'privacy-policy',
    PROMOCODE_HELLO_JETVIX: 'promocode-hello-jetvix',
    PWA_IOS_INSTRUCTION: 'pwa-ios-instruction',
    LEADERBOARD_NOTIFICATION_LEAGUE: 'leaderboard-notification-league',
    REFERRAL: 'referral',
    REFERRAL_RULES: 'referral-rules',
    REFERRAL_RECEIVED_REWARD: 'referral-received-reward',
    REFERRAL_GIFT_REWARD: 'referral-gift-reward',
    REFERRAL_WARNING_RESET_PROGRESS: 'referral-warning-reset-progress',
    REFERRAL_SHARE_LINK: 'referral-share-link',
    REFERRAL_SHARE_QR_CODE: 'referral-share-qr-code',
    REFERRAL_RESPAWN_TIMER: 'referral-respawn-timer',
    REFILL: 'refill',
    REQUEST_FEEDBACK: 'request-feedback',
    RESPAWN: 'respawn',
    RESPAWN_MOTIVATION: 'respawn_motivation',
    SETTINGS: 'settings',
    TUTORIALS: 'tutorials',
    TUTORIAL_VIDEO: 'tutorial-video',
    USER_STATE_INFORMATION: 'user-state-information',
    USER_STATUSES: 'user-statuses',
    USER_STATUS_CONGRATULATIONS: 'status-congratulations',
    VERIFY: 'verify',
    VERIFY_MANUAL: 'verify-manual',
    VERIFY_SUMSUB: 'verify-sumsub',
    VERIFY_REQUEST: 'verify-request',
    WELCOME_APP: 'welcome-app',
    WITHDRAW: 'withdraw',
    WITHDRAWAL_CANCEL: 'withdrawal-cancel',
    WITHDRAWAL_LIMITS: 'withdrawal-limits',
} as const;

export type IMobileSliderPageId = typeof MOBILE_SLIDER_PAGES_IDS[keyof typeof MOBILE_SLIDER_PAGES_IDS];
